import { CLIMATE_FEATURES } from 'src/app/dashboards/models/features/climate-features';
import { ENVIRONMENT_FEATURES } from 'src/app/dashboards/models/features/environment-features';
import { HISTORY_FEATURES } from 'src/app/dashboards/models/features/history-features';

export const FEATURES = {
  modules: {
    environment: ENVIRONMENT_FEATURES,
    climate: CLIMATE_FEATURES,
    history: HISTORY_FEATURES,
  },
};
